













































































































import { IJobMatchProfile, IJobmatchSearchParams, IResultPage } from '@app/componentlib/common/types/JobMatchTypes'
import Vue from 'vue'
import Component from 'vue-class-component'
import BannerWithImageAndText from '@app/componentlib/src/views/components/BannerWithImageAndText.vue'
import JobResultSkeleton from '@app/componentlib/src/views/components/job-components/JobResultSkeleton.vue'
import MinimalisticDropdown from '@app/componentlib/src/views/components/MinimalisticDropdown.vue'
import LocationComponentsContainer from '@app/componentlib/src/views/components/location-components/LocationComponentsContainer.vue'
import JobViewContainer from '@app/componentlib/src/views/components/job-components/JobViewContainer.vue'
import { IJobmatchResult, IJobPosting, ISettingsItem } from '@app/componentlib/src/common/types/JobSearchTypes'
import { IOccupation } from '@app/componentlib/src/common/types/JobMatchTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'
import { IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { IRegion } from '@app/componentlib/common/types/LocationTypes'
import { JobMatchModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatch'
import { JobMatchOccupationModule } from '@app/componentlib/src/store/modules/JobMatch/jobMatchOccupations'
import JobSearchFilters from '@app/componentlib/src/views/jobsearch-pages/JobSearchFilters.vue'
import { JobSearchModule } from '@app/componentlib/src/store/modules/jobSearch'
import MobileButtonBottom from '@app/componentLib/src/views/components/shared/MobileButtonBottom.vue'

@Component<ResultPage>({
  props: {
    content: Object,
    translations: Object,
    settings: Object,
    jobApplicationAccess: Boolean
  },
  components: {
    BannerWithImageAndText,
    MinimalisticDropdown,
    LocationComponentsContainer,
    JobResultSkeleton,
    JobViewContainer,
    JobSearchFilters,
    MobileButtonBottom,
  }
})

export default class ResultPage extends Vue {
  /**
   * Props variables
   */
  content: IResultPage | undefined
  translations: object | undefined
  settings: ISettingsItem | undefined
  jobApplicationAccess: boolean | undefined

  /**
   * Component state variables
   */
  isLoading: boolean = false
  componentKey: number = 0
  isSearching: boolean = false
  locationToInit: IRegion = {
    postal: this.jobmatchProfile.geoSettings?.zipCode || '',
    radius: this.jobmatchProfile.geoSettings?.radiusKm || 0,
    type: '',
    city: this.jobmatchProfile.geoSettings?.city || '',
    mapViewText: '',
    lat: this.jobmatchProfile.geoSettings?.latitude || 0,
    lon: this.jobmatchProfile.geoSettings?.longitude || 0
  }
  countryToInit: string = this.jobmatchProfile.geoSettings?.country ?? ''
  filterIsActive: boolean = false
  today = new Date()
  mobileFilterIsActive: boolean = false
  jumpToStepFromStorage: string = sessionStorage.getItem('stepToJumpTo') || ''
  showPage: boolean = false
  filtersToExclude: String[] = this.jobmatchProfile.geoSettings?.country === 'FI' ? ['jobCategories', 'industries'] : ['jobCategories']

  /**
   * Lifecycle
   */
  async mounted () {
    if (this.jumpToStepFromStorage !== 'undefined' && this.jumpToStepFromStorage !== '' && this.jumpToStepFromStorage !== undefined)
      window.location.replace(this.content?.backToJobWizardLinkPicker + '?jumpToStep=' + this.jumpToStepFromStorage)
    else
      this.showPage = true

    //Start search as soon as resultpage is mounted
    this.startSearch(false)
    await this.setDates()
    JobMatchModule.setShowAllOccupations(this.isMobile === true ? false : true)

    JobMatchModule.setSettings(this.settings)
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get jobResult (): IJobmatchResult | undefined {
    return JobMatchModule.jobResult
  }

  get jobPostings (): IJobPosting[] {
    return JobMatchModule.jobPostings ?? []
  }

  get selectedJobPosting (): IJobPosting | undefined {
    return JobMatchModule.selectedJobPosting
  }

  get jobPostingsTotalAmount (): number {
    return JobMatchModule.jobResult?.TotalResults ?? 0
  }

  get selectedOccupations (): IOccupation[] {
    return JobMatchOccupationModule.selectedOccupations
  }

  get selectedOccupationsCount (): number {
    return JobMatchOccupationModule.selectedOccupations.length
  }

  get searchParams (): IJobmatchSearchParams {
    return JobMatchModule.jobmatchSearchParams
  }

  get jobmatchProfile (): IJobMatchProfile {
    return JobMatchModule.jobMatchProfile
  }

  get userInfo (): IUserInfo | undefined {
    return JobMatchModule.userInfo
  }

  get isMobile (): boolean {
    return AppModule.isMobile
  }

  get activeIndex (): Number {
    return JobMatchModule.activeIndex
  }

  get showAllOccupations (): Boolean {
    return JobMatchModule.showAllOccupations
  }

  get iconOnJumpToStepButton (): string {
    if (this.content?.jumpToWizardStepLink === 'wizardStepJobMatchEmailNotification')
      return 'envelope'
    else if (this.content?.jumpToWizardStepLink === 'wizardStepJobMatchLocation')
      return 'geo-alt-fill'
    else
      return 'briefcase'
  }

  /**
   * Methods
   */
  goToPage (url?: string): void {
    if (url !== null && url !== "") {
      window.open(url, '_self')
    }
  }

  async startSearch (isFromLocation: boolean) {
    // Check if search is started from location, if yes its location needs to be saved to jobmatch profile.
    if (isFromLocation) {
      let tempProfile = this.jobmatchProfile

      if (LocationModule.locations.length > 0) {
        const { postal, city, radius, lat, lon } = LocationModule.locations[0]
        tempProfile.geoSettings = {
          zipCode: postal,
          city: city,
          radiusKm: radius,
          latitude: lat,
          longitude: lon,
          country: LocationModule.selectedCountry.countryCode
        }
      }
      this.filtersToExclude = tempProfile.geoSettings?.country === 'FI' ? ['jobCategories', 'industries'] : ['jobCategories']

      await JobMatchModule.updateJobMatchProfile(tempProfile)
    }

    await JobMatchModule.startSearch(true)
      .finally(() => {
        this.isLoading = false
        this.isSearching = false
      })
  }

  async searchForMore () {
    // Check if offset his les than totalamount, if yes then we can still get more jobpostings
    if (this.searchParams.offset < this.jobPostingsTotalAmount && this.isSearching === false) {
      this.isSearching = true
      await JobMatchModule.startSearch(false)
        .finally(() => {
          this.isSearching = false
          this.isLoading = false
        })
    }
  }

  changeJobMatchProfile () {
    JobMatchModule.setShowResultPage(false)
  }

  async resetProfileGeo () {
    await JobMatchModule.emptyProfileLocationData()
    await this.startSearch(true)
  }

  badgeClicked (item: IOccupation) {
    JobMatchOccupationModule.removeOccupation(item).then(() => {
      this.startSearch(false)
    })
  }

  changeFilterActive () {
    this.filterIsActive = !this.filterIsActive
  }

  showAll () {
    JobMatchModule.setShowAllOccupations(!this.showAllOccupations)
  }

  async setDates () {
    await JobSearchModule.setDates([
      {
        Id: 1,
        Name: this.t.jobSearch_V2_24_Hours,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 1).toString()
      },
      {
        Id: 2,
        Name: this.t.jobSearch_V2_One_Week,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 7).toString()
      },
      {
        Id: 3,
        Name: this.t.jobSearch_V2_Two_Weeks,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 14).toString()
      },
      {
        Id: 4,
        Name: this.t.jobSearch_V2_One_Month,
        Date: new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() - 30).toString()
      },
    ])
  }

  async setActiveIndex (index: number) {
    JobMatchModule.setActiveIndex(index)
  }

  async setSelectedJobPosting (posting: IJobPosting) {
    JobMatchModule.setSelectedJobPosting(posting)
  }

  changeMobileFiltersIsOpen (bool: boolean) {
    this.mobileFilterIsActive = bool
  }
}
